import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {getDeliveryAddressFee} from '@web/actions/deliveryInfo'
import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {recalculateAction, getInitialState} from '@web/slices/orderTotal/slice'

import type {OrderTotalReducers, MakeSliceOptions} from './interfaces'
import type {OrderTotalState} from '@web/slices/orderTotal/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<OrderTotalState, OrderTotalReducers, 'orderTotal', SliceSelectors<OrderTotalState>>({
        name: 'orderTotal',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(recalculateAction, (state, {payload}) => {
                    state.discountAmount = payload.totalDiscountAmount
                    state.productDiscountAmount = payload.productDiscountAmount
                    state.deliveryDiscountAmount = payload.deliveryDiscountAmount
                })
                .addCase(getDeliveryAddressFee.fulfilled, (state, {payload}) => {
                    state.deliveryFeeAmount = payload.data.delivery.totalPrepayOrderDeliveryFee
                    if (state.escrow) {
                        state.escrow.deliveryFeeAmount = payload.data.deliveryFeeCommissionAmount ?? 0
                    }
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.orderTotal ?? state
            })
        },
    })
